<template>
  <div
    v-if="linked.length > 0"
    class="alert alert-info d-flex align-items-center gap-3 mb-5"
  >
    <i class="ki-outline ki-link fs-2 text-primary"/>
    <div class="fw-bold">
      Полис {{ contractGlobal }} связан с другими полисами:
      <span v-for="item in linked" :key="item.global">
        {{ item.global }} ({{ item.product }})
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BpmRewriteLinkedAlert',
  props: {
    contractGlobal: {
      type: String,
      default: '',
    },
    linked: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
